import config from "config";

export const ORGANIZATION_FIELDS = `
id
website @include(if: $isAuth)
${config.RAISED_SORTING_FIELD}
verticalProfiles(where:{vertical: ${config.VERTICAL}}) {
  id
  vertical
  keySources
  partnerships(where:{vertical: ${config.VERTICAL}}) @include(if: $isAuth) {
    id
    date
    description
    source
    updatedAt
    createdAt
    status
    vertical
    verticalProfiles {
      id
      entity {
        id
        name
        logo
        vertical
      }
      entityTypeProfiles {
        entityType
      }
    }
  }
  memberOfConsortiums @include(if: $isAuth) {
    id
    verticalProfiles {
      id
      entity {
        id
        name
        logo
      }
    }
  }
  entityTypeProfiles(where:{entityType: ORGANIZATION}) {
    id
    entityType
    status
    cloudOffering @include(if: $isAuth)
    simulatorOffering @include(if: $isAuth)
    consultingOffering @include(if: $isAuth)
    cpuOffering
    gpuOffering
    offersQcaas
    offersQpu
    softwareOffering @include(if: $isAuth)
    quantumLibrary @include(if: $isAuth)
    quantumAlgorithms @include(if: $isAuth)
    quantumCircuit @include(if: $isAuth)
    assemblyLanguage @include(if: $isAuth)
    spaceHeritage(options: {sort: { launchDate: DESC }}) @include(if: $isAuth) {
      id
      satelliteName
      country {
        id
        name
      }
      satelliteMissionSegment
      launchDate
    }
    acquiredBy @include(if: $isAuth) {
      id
      verticalProfiles {
        entity {
          id
          name
          logo
        }
      }
    }
    acquisitions @include(if: $isAuth) {
      id
      verticalProfiles {
        vertical
        entity {
          id
          name
          logo
        }
      }
    }
    acquiredByConnection @include(if: $isAuth) {
      edges {
        node {
          verticalProfiles {
            entity {
              id
              name
              logo
            }
          }
        }
        properties {
          date
          description
          source
        }
      }
    }
    raised @include(if: $isAuth)
    techDetail @include(if: $isAuth)
    hasQubitImplementations @include(if: $isAuth) {
      id
      name
    }
    organizationFacilitatesAccessTo {
      id
      verticalProfiles {
        entity {
          id
          name
          logo
        }
      }
    }
    inClassification(where:{vertical: ${config.VERTICAL}}) @include(if: $isAuth) {
      id
      name
      description
      childOf {
        id
        name
        description
      }
    }
    facilitatesAccessToOrganizations {
      id
      verticalProfiles {
        entity {
          id
          name
          logo
        }
      }
    }
    fundingRounds (
      options: { sort: { startDate: DESC } }
      where: $fundingRoundsWhere
    ) {
      investors {
        id
        verticalProfiles {
            entity {
              id
              name
              logo
            }
        }
        investedInConnection {
          edges {
            properties {
              isLead
            }
            node {
              id
            }
          }
        }
      }
      id
      type
      startDate
      source
      fundingUsd
      status
    }
    fundingRoundsAggregate(where: $fundingRoundsWhere) {
      node {
        fundingUsd {
          sum
        }
      }
    }
    spinoutFrom @include(if: $isAuth) {
      id
      verticalProfiles {
        entity {
          id
          name
          logo
        }
      }
    }
    ofType @include(if: $isAuth) {
        id
        name
        description
    }
    offers @include(if: $isAuth) {
        id
        name
        description
    }
  }
}
city
state
inCountry {
  name
  region {
    id
    name
  }
  states {
    name
    abbreviation
  }
}
createdAt
description
employeeRange
founded
lat
linkedIn @include(if: $isAuth)
lng
logo
name
updatedAt
lastUpdatedBy @include(if: $isAdmin)
vertical
status
symbol
aliases
`;
